module.exports = __webpack_public_path__ + "img/recommed-img4.a7d0aa46.jpg";